import React from 'react';
import MainStore from '../../../MainStore';
import SuggestionsStore from './SuggestionsStore';
import AuthStore from '../../Auth/AuthStore'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react';

const SuggestionFlagDialog = observer(class SuggestionFlagDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }

        this.handleCommentSave = this.handleCommentSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleCommentSave() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Suggestion/FlagAndComment', {
            method: 'POST',
            body: JSON.stringify({ WorkId: SuggestionsStore.suggestionId, Comment: this.state.flagComment, Flag: SuggestionsStore.newFlag }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    /*if (scope.props.onSuggestionUpdate) {
                        scope.props.onSuggestionUpdate(result)
                    }*/
                    SuggestionsStore.updateSuggestion(result);
                    MainStore.setMaskUnvisible();
                    SuggestionsStore.closeCommentDialog();
                    //scope.setState({ isCommentDialogOpen: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleCommentClose() {
        SuggestionsStore.closeCommentDialog();
    }

    render() {
        return (
            <Dialog
                onClose={this.handleCommentClose}
                aria-labelledby="customized-dialog-title"
                open={SuggestionsStore.getIsCommentDialogOpen}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="customized-dialog-title" onClose={this.handleCommentClose}>
                    {SuggestionsStore.flagDialogTitle}
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        <TextField required
                            id="standard-required"
                            label="Комментарий"
                            fullWidth
                            margin="normal"
                            value={this.state.flagComment}
                            multiline
                            onChange={this.handleChange('flagComment')}
                        />
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCommentSave} color="primary">
                        Сохранить
                    </Button>
                    <Button onClick={this.handleCommentClose} color="primary">
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
})

export default SuggestionFlagDialog;